import Actions from '../actions/actions';
import AudiencesActions from '../actions/AudiencesCRUDActions';
import { normalizeVariableName } from '../helpers/variable-names-helper';
import {
  AudienceDetails,
  AudienceDetailsContacts,
  Audiences,
} from '../interfaces/audiences';
import AudiencesModel from '../model/AudiencesModel';
import {
  retrieved,
  retrievedAll,
  setBusy,
  setUnBusy,
} from './common/commonReducers';

const initialState: Audiences = {
  busy: false,
  entities: [],
  audienceDetails: null,
  converetedLeadsAudience: null,
  variables: [],
  contactsCSVBlob: null,
  pagination: {
    total: 0,
    page: 0,
    perPage: 25,
    totalPages: 0,
    isLastPage: false,
  },
  sorting: {},
};

const getAudienceWithoutContacts = (
  audienceDetails: AudienceDetails,
): AudiencesModel => {
  const { contacts, ...audienceWithoutContacts } = audienceDetails;
  return audienceWithoutContacts;
};

const replaceUpdatedAudience = (
  state: Audiences,
  audienceDetails: AudienceDetails,
) => {
  const { entities } = state;
  return {
    ...state,
    entities: entities.map(a =>
      a.id === audienceDetails.id
        ? getAudienceWithoutContacts(audienceDetails)
        : a,
    ),
  };
};

export default function forms(state = initialState, action): Audiences {
  switch (action.type) {
    case AudiencesActions.busyAction:
      return setBusy(state, { contactsCSVBlob: null });
    case AudiencesActions.updateAction: {
      return {
        ...replaceUpdatedAudience(state, action.entity),
        busy: false,
        audienceDetails: action.entity,
      };
    }
    case AudiencesActions.deleteLocalAction: {
      const { entity: removedEntityId } = action;
      const entities = state.entities.filter(
        audience => audience.id !== removedEntityId,
      );
      return {
        ...state,
        busy: false,
        entities,
        audienceDetails:
          removedEntityId === state.audienceDetails?.id
            ? null
            : state.audienceDetails,
      };
    }
    case AudiencesActions.retrievedAllAction: {
      const {
        audiences = [],
        pagination,
        mergeResults,
        sorting,
      } = action.entities;
      const { entities } = retrievedAll(
        state,
        { entities: audiences },
        mergeResults,
      );
      return {
        ...state,
        busy: false,
        entities,
        converetedLeadsAudience:
          audiences.find(a => a.type === 'converted_leads') ||
          state.converetedLeadsAudience,
        pagination: {
          ...state.pagination,
          ...pagination,
        },
        sorting: {
          ...(sorting.sortColumn && { sortColumn: sorting.sortColumn }),
          ...(sorting.sortDirection && {
            sortDirection: sorting.sortDirection,
          }),
        },
      };
    }
    case AudiencesActions.retrievedAction: {
      const audienceDetails = {
        ...action.entity,
      };

      const { entities } = retrieved(state, action);
      return {
        ...state,
        busy: false,
        entities,
        audienceDetails,
      };
    }

    case AudiencesActions.getAudienceContacts: {
      if (!state.audienceDetails) {
        return state;
      }
      const audienceDetails = {
        ...state.audienceDetails,
        contacts: action.entity as AudienceDetailsContacts,
      };
      return {
        ...state,
        busy: false,
        audienceDetails,
      };
    }

    case AudiencesActions.getAudienceVariablesAction: {
      const { entities } = action;
      return {
        ...state,
        busy: false,
        variables: entities.map(entity => ({
          ...entity,
          friendlyName: normalizeVariableName(
            entity.friendlyName ? entity.friendlyName : entity.name,
          ),
        })),
      };
    }

    case AudiencesActions.getVariableOptionsAction: {
      const {
        entities: { variableOperators, variableOptions, variableDataKind },
      } = action;
      return {
        ...state,
        busy: false,
      };
    }

    case AudiencesActions.getAllCSV: {
      const { csvBlob } = action;
      return {
        ...state,
        busy: false,
        contactsCSVBlob: csvBlob,
      };
    }
    case AudiencesActions.clearAudienceDetails: {
      return { ...state, audienceDetails: null };
    }
    case AudiencesActions.resetAudiencesAction: {
      return initialState;
    }

    case AudiencesActions.unbusyAction:
      return setUnBusy(state);
    case Actions.UNBUSY: {
      return { ...state, busy: false };
    }
    case Actions.RESET:
      return initialState;
    default:
      return state;
  }
}
